import moment from "moment";

/**
 * Convierte un moment a segundos desde medianoche (00:00:00)
 * @param {moment.Moment} t
 * @returns {number|null} 0..86399
 */
const timeToSeconds = (t) => {
  if (!t || !moment.isMoment(t)) return null;

  const hh = t.hours();
  const mm = t.minutes();
  const ss = t.seconds();

  return (hh * 3600) + (mm * 60) + ss;
};

/**
 * Convierte segundos desde medianoche a un moment
 * @param {number} secs
 * @returns {moment.Moment|null}
 */
const secondsToHms = (secs) => {
  const x = Number(secs);
  if (!Number.isFinite(x)) return null;

  // Normalizar a rango 0..86399
  const s = ((x % 86400) + 86400) % 86400;

  const hh = Math.floor(s / 3600);
  const mm = Math.floor((s % 3600) / 60);
  const ss = s % 60;

  return moment()
    .hours(hh)
    .minutes(mm)
    .seconds(ss)
    .milliseconds(0);
};

export {
  timeToSeconds,
  secondsToHms,
};